<template>
  <form class="address-form-saved" @submit.prevent="onSubmit" novalidate>
    <OptionRadio
      v-for="(address, i) in addresses"
      :key="`${i}-${address.id}`"
      :id="address.id.toString()"
      :selectedId="selectedAddressIdString"
      name="addresses"
      :isDisabled="isSubmitting || isDisabled"
      v-data-test-id="'address-form-saved__address'"
      @update:selectedId="$emit('update', Number($event))"
    >
      <AddressSingleline :address="address" :hiddenAddressFields="hiddenAddressFields" />
    </OptionRadio>
    <slot name="below-radio" />
    <ButtonContainer
      v-show="isSubmitButtonVisible"
      :buttonText="submitButtonText"
      :isInactive="isSubmitButtonInactive"
      :isSubmitting="isSubmitting"
    />
  </form>
</template>

<script>
import to from 'await-to-js'
import OptionRadio from '@/components/_shared/Form/Radio/OptionRadio.vue'
import AddressSingleline from '@/components/_shared/AddressSingleline.vue'
import ButtonContainer from '@/components/_shared/Form/ButtonContainer.vue'

export default {
  name: 'AddressFormSaved',
  components: {
    OptionRadio,
    AddressSingleline,
    ButtonContainer,
  },

  props: {
    addresses: {
      type: Array,
      required: true,
    },
    selectedAddressId: {
      type: Number,
      default: -1,
    },
    handleSubmit: {
      type: Function,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isSubmitButtonVisible: {
      type: Boolean,
      default: false,
    },
    isSubmitButtonInactive: {
      type: Boolean,
      default: false,
    },
    submitButtonText: {
      type: String,
      required: true,
    },
    hiddenAddressFields: {
      type: Array,
    },
  },

  data() {
    return {
      isSubmitting: false,
    }
  },

  computed: {
    selectedAddressIdString() {
      return this.selectedAddressId?.toString()
    },
  },

  methods: {
    async onSubmit() {
      this.$emit('click-submit')
      this.isSubmitting = true
      await to(this.handleSubmit(this.selectedAddressId))
      this.isSubmitting = false
    },
  },
}
</script>

<style scoped lang="scss">
.address-form-saved {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: space(5);
}
</style>
